<template>
    <PopupRouterViewDetail label="Work Order Execution Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Work Order Execution" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" label="LotNo" :model="(model.workOrderProcessDetail != null) ? model.workOrderProcessDetail.lotNo : null"  />
						<app-input-combobox-autocomplete :isEditable="false" :options="shifts" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Shift" id="fieldset-shift" size="sm" :model.sync="model.shiftId"   :selected="model.shift != null ? model.shift.name : ''" @input="getShifts" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedShift" />
						<app-label label-cols-lg="12" size="sm" label="Machine" :model="(model.machine != null) ? model.machine.name : null"  />
						<app-input-datetimepicker :isEditable="false" id="fieldset-start-production" label-cols-lg="12"  label="Start Production" size="sm" :model.sync="model.startProduction"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" label="Sub Process Number" :model="(model.billOfProcessDetail != null) ? model.billOfProcessDetail.subProcessNumber : null"  />
						<app-input-combobox-autocomplete :isEditable="false" :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Operator" id="fieldset-operator" size="sm" :model.sync="model.operatorUserName"   :selected="model.operator != null ? model.operator.firstName : ''" @input="getUserInfos" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedOperator" />
						<app-input-textbox :isEditable="false" id="fieldset-qty-plan" label-cols-lg="12"  label="Qty Plan" label-for="input-qty-plan" size="sm" :model.sync="model.qtyPlan"  @change="updateData"  :isUpdatable="true" />
						<app-input-datetimepicker :isEditable="false" id="fieldset-finish-production" label-cols-lg="12"  label="Finish Production" size="sm" :model.sync="model.finishProduction"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="true" />
				</b-col>

				<b-col cols="12" lg="12">
					<app-table-input-custom title="Execution Control Time" :bordered="true" :items="workOrderExecutionControlTimes" :fields="fieldsWorkOrderExecutionControlTime" :busy="isDataLoading" :sort-by.sync="sortByWorkOrderExecutionControlTime" :sort-desc.sync="sortDescWorkOrderExecutionControlTime" small responsive
						:showActionButton="false"
						:showEditButton="false"
						:showDeleteButton="false"
						:showAddButton="false"
						:showAddFromClipboardButton="false"
						:showReplaceFromClipboardButton="false"
						:showUploadButton="false"
						:showDownloadButton="false"
						:isDownloadBusy="isDownloadWorkOrderExecutionControlTime"
						>
						<template v-slot:cell(no)="row">
							{{ ((row.index + 1) + ( workOrderExecutionControlTimePageSize * (currentWorkOrderExecutionControlTimePage - 1))) }}
						</template>
						<template v-slot:table-busys>
							<div class="text-center my-2">
								<b-spinner class="align-middle text-primary"></b-spinner>
								<strong class="ml-2">Loading...</strong>
							</div>
						</template>
						<template v-slot:cell(productionControlTime)="row">
							<app-input-combobox-autocomplete :options="productionControlTimeDetails" optionsLabel="standarTimeId" optionsKey="id" :id="'input-work-order-execution-control-time-production-control-time-' + row.index" label-cols-lg="12" label="Production Control Time" size="sm" :model.sync="row.item.productionControlTimeId"  @change="saveInputWorkOrderExecutionControlTime(row.item)" :selected="row.item.productionControlTime != null ? row.item.productionControlTime.standarTimeIdStandarTimeName : ''"  @input="getProductionControlTimeDetails" :loading="isProductionControlTimeDetailComboLoading"   :isUpdatable="true"   :nolabel="true" :isEditable="false" />
						</template>
						<template v-slot:cell(startControlTime)="row">
							<app-input-datetimepicker :id="'input-work-order-execution-control-time-start-control-time-' + row.index" label-cols-lg="12" label="Start Control Time" size="sm" :model.sync="row.item.startControlTime"   @change="saveInputWorkOrderExecutionControlTime(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="true"   :nolabel="true" :isEditable="false" />
						</template>
						<template v-slot:cell(stopControlTime)="row">
							<app-input-datetimepicker :id="'input-work-order-execution-control-time-stop-control-time-' + row.index" label-cols-lg="12" label="Stop Control Time" size="sm" :model.sync="row.item.stopControlTime"   @change="saveInputWorkOrderExecutionControlTime(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="true"   :nolabel="true" :isEditable="false" />
						</template>
					</app-table-input-custom>
				</b-col>

				<b-col cols="12" lg="12">
					<app-table-input-custom title="Execution Hold Time" :bordered="true" :items="workOrderExecutionHoldTimes" :fields="fieldsWorkOrderExecutionHoldTime" :busy="isDataLoading" :sort-by.sync="sortByWorkOrderExecutionHoldTime" :sort-desc.sync="sortDescWorkOrderExecutionHoldTime" small responsive
						:showActionButton="false"
						:showEditButton="false"
						:showDeleteButton="false"
						:showAddButton="false"
						:showAddFromClipboardButton="false"
						:showReplaceFromClipboardButton="false"
						:showUploadButton="false"
						:showDownloadButton="false"
						:isDownloadBusy="isDownloadWorkOrderExecutionHoldTime"
						>
						<template v-slot:cell(no)="row">
							{{ ((row.index + 1) + ( workOrderExecutionHoldTimePageSize * (currentWorkOrderExecutionHoldTimePage - 1))) }}
						</template>
						<template v-slot:table-busys>
							<div class="text-center my-2">
								<b-spinner class="align-middle text-primary"></b-spinner>
								<strong class="ml-2">Loading...</strong>
							</div>
						</template>
						<template v-slot:cell(startTime)="row">
							<!-- <app-input-datetimepicker :id="'input-work-order-execution-hold-time-start-time-' + row.index" label-cols-lg="12" label="Start Time" size="sm" :model.sync="row.item.startTime" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="true"   :nolabel="true" :isEditable="false" /> -->
							 {{ row.item.startTime | moment('DD-MMM-YYYY HH:mm') }}
						</template>
						<template v-slot:cell(endTime)="row">
							<!-- <app-input-datetimepicker :id="'input-work-order-execution-hold-time-stop-time-' + row.index" label-cols-lg="12" label="End Time" size="sm" :model.sync="row.item.endTime" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="true"   :nolabel="true" :isEditable="false" /> -->
							{{ row.item.endTime | moment('DD-MMM-YYYY HH:mm') }}
						</template>
						<template v-slot:cell(remark)="row">
							{{ row.item.remark }}
						</template>
					</app-table-input-custom>
				</b-col>

				<b-col cols="12" lg="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Result 1" v-if="workOrderExecutionDetails.length > 0" active>
								<b-card-text>
									<b-row>
										<b-col cols="12" lg="6">
											<app-label label-cols-lg="12" size="md" label="Part No" :model="workOrderExecutionDetails[0].part != null ? workOrderExecutionDetails[0].part.partNumber : null"></app-label>
											<app-input-textbox :id="'input-good-qty'" label-cols-lg="12" label="Good Qty" size="sm" :model.sync="workOrderExecutionDetails[0].goodQty"   @change="updateDataWorkOrderDetail(workOrderExecutionDetails[0], workOrderExecutionDetails[0].id)" :isEditable="false" />
										</b-col>
										<b-col cols="12" lg="6">
											<app-label label-cols-lg="12" size="md" label="Part Name" :model="workOrderExecutionDetails[0].part != null ? workOrderExecutionDetails[0].part.partName : null"></app-label>
											<app-input-textbox :id="'input-pending-qty'" label-cols-lg="12" label="Pending Qty" size="sm" :model.sync="workOrderExecutionDetails[0].pendingQty"   @change="updateDataWorkOrderDetail(workOrderExecutionDetails[0], workOrderExecutionDetails[0].id)" :isEditable="false" />
										</b-col>
										<b-col cols="12" lg="12">
											<app-table-input-custom 
												title = "Ng Qty"
												:bordered="true" :items="workOrderExecutionNgs1" 
												:fields="fieldsWorkOrderExecutionNg" 
												:busy="isDataLoading" 
												:sort-by.sync="sortByWorkOrderExecutionNg" 
												:sort-desc.sync="sortDescWorkOrderExecutionNg" small responsive
												:showActionButton="false"
												:showDeleteButton="false"
												:showAddButton="false"
												:showAddFromClipboardButton="false"	
												:showReplaceFromClipboardButton="false"	
												:showUploadButton="false"	
												:showDownloadButton="false">						
													
												<template v-slot:cell(no)="row">
													{{ (row.index + 1) }}
												</template>
																	
												<template v-slot:table-busys>
													<div class="text-center my-2">
														<b-spinner class="align-middle text-primary"></b-spinner>
														<strong class="ml-2">Loading...</strong>
													</div>
												</template>
																	
												<template v-slot:cell(ngCategory)="row">
													<app-label label-cols-lg="12" size="md" label="Ng Category" :model="row.item.ngCategory != null ? row.item.ngCategory.name : ''" :nolabel="true" :isEditable="false" />
												</template>
												<template v-slot:cell(ngQty)="row">
													<app-label label-cols-lg="12" size="md" label="Ng Qty" :model="row.item.ngQty" :nolabel="true" :isEditable="false" />
												</template>
											</app-table-input-custom>
										</b-col>
									</b-row>									
								</b-card-text>
							</b-tab>
							<b-tab title="Result 2" v-if="workOrderExecutionDetails.length > 1">
								<b-card-text>
									<b-row>
										<b-col cols="12" lg="6">
											<app-label label-cols-lg="12" size="md" label="Part No" :model="workOrderExecutionDetails[1].part != null ? workOrderExecutionDetails[1].part.partNumber : null"></app-label>
											<app-input-textbox :id="'input-good-qty'" label-cols-lg="12" label="Good Qty" size="sm" :model.sync="workOrderExecutionDetails[1].goodQty"   @change="updateDataWorkOrderDetail(workOrderExecutionDetails[1], workOrderExecutionDetails[1].id)" :isEditable="false" />
										</b-col>
										<b-col cols="12" lg="6">
											<app-label label-cols-lg="12" size="md" label="Part Name" :model="workOrderExecutionDetails[1].part != null ? workOrderExecutionDetails[1].part.partName : null"></app-label>
											<app-input-textbox :id="'input-pending-qty'" label-cols-lg="12" label="Pending Qty" size="sm" :model.sync="workOrderExecutionDetails[1].pendingQty"   @change="updateDataWorkOrderDetail(workOrderExecutionDetails[1], workOrderExecutionDetails[1].id)" :isEditable="false" />
										</b-col>
										<b-col cols="12" lg="12">
											<app-table-input-custom 
												title = "Ng Qty"
												:bordered="true" :items="workOrderExecutionNgs2" 
												:fields="fieldsWorkOrderExecutionNg" 
												:busy="isDataLoading" 
												:sort-by.sync="sortByWorkOrderExecutionNg" 
												:sort-desc.sync="sortDescWorkOrderExecutionNg" small responsive	
												:showActionButton="false"
												:showDeleteButton="false"
												:showAddButton="false"
												:showAddFromClipboardButton="false"	
												:showReplaceFromClipboardButton="false"	
												:showUploadButton="false"	
												:showDownloadButton="false">						
													
												<template v-slot:cell(no)="row">
													{{ (row.index + 1) }}
												</template>
																	
												<template v-slot:table-busys>
													<div class="text-center my-2">
														<b-spinner class="align-middle text-primary"></b-spinner>
														<strong class="ml-2">Loading...</strong>
													</div>
												</template>
																	
												<template v-slot:cell(ngCategory)="row">
													<app-label label-cols-lg="12" size="md" label="Ng Category" :model="row.item.ngCategory != null ? row.item.ngCategory.name : ''" :nolabel="true" :isEditable="false" />
												</template>
												<template v-slot:cell(ngQty)="row">
													<app-label label-cols-lg="12" size="md" label="Ng Qty" :model="row.item.ngQty" :nolabel="true" :isEditable="false" />
												</template>
											</app-table-input-custom>
										</b-col>
									</b-row>

								</b-card-text>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
            </b-row>
        </b-card>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
import WorkOrderExecutionList from '@/models/WorkOrderExecution/WorkOrderExecutionList';
import WorkOrderExecutionFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionFilter';
import moment from 'moment';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Shift from '@/models/Shift/Shift';
import ShiftFilter from '@/filters/Shift/ShiftFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import BillOfProcessDetail from '@/models/BillOfProcess/BillOfProcessDetail';
import BillOfProcessDetailFilter from '@/filters/BillOfProcess/BillOfProcessDetailFilter';
import AppLabel from '@/components/AppLabel';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import WorkOrderExecutionDetail from '@/models/WorkOrderExecution/WorkOrderExecutionDetail';
import WorkOrderExecutionDetailFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionDetailFilter';
import WorkOrderExecutionControlTime from '@/models/WorkOrderExecution/WorkOrderExecutionControlTime';
import WorkOrderExecutionControlTimeFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionControlTimeFilter';
import WorkOrderExecutionHoldTime from '@/models/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTime';
import WorkOrderExecutionHoldTimeFilter from '@/filters/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTimeFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputCustom from '@/components/AppTableInputCustom';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import WorkOrderExecutionDetailInput from '@/views/WorkOrderExecution/WorkOrderExecutionDetailInput';
import WorkOrderExecutionDetailUpload from '@/views/WorkOrderExecution/WorkOrderExecutionDetailUpload';
import ProductionControlTimeDetail from '@/models/ProductionControlTime/ProductionControlTimeDetail';
import ProductionControlTimeDetailFilter from '@/filters/ProductionControlTime/ProductionControlTimeDetailFilter';
import WorkOrderExecutionControlTimeInput from '@/views/WorkOrderExecution/WorkOrderExecutionControlTimeInput';
import WorkOrderExecutionControlTimeUpload from '@/views/WorkOrderExecution/WorkOrderExecutionControlTimeUpload';
import PopupRouterView from '@/components/PopupRouterView';
import WorkOrderExecutionNg from '@/models/WorkOrderExecutionNg/WorkOrderExecutionNg';
import WorkOrderExecutionNgFilter from '@/filters/WorkOrderExecutionNg/WorkOrderExecutionNgFilter';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		WorkOrderExecutionDetailInput,WorkOrderExecutionDetailUpload,
		WorkOrderExecutionControlTimeInput,WorkOrderExecutionControlTimeUpload,
		AppTableInput,
		AppTableInputPopup,
		AppTableInputCustom,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsWorkOrderExecutionControlTime: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"productionControlTime": { "class" : "th-production-control-time first-child", "label" : "Production Control Time", key: 'productionControlTime', sortable: false}}, 
				{"startControlTime": { "class" : "th-start-control-time", "label" : "Start Control Time", key: 'startControlTime', sortable: false}}, 
				{"stopControlTime": { "class" : "th-stop-control-time", "label" : "Stop Control Time", key: 'stopControlTime', sortable: false}}, 
			],
			fieldsWorkOrderExecutionHoldTime: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"startTime": { "class" : "th-start-time", "label" : "Start Time", key: 'startTime', sortable: false}}, 
				{"endTime": { "class" : "th-end-time", "label" : "End Time", key: 'endTime', sortable: false}}, 
				{"remark": { "class": "th-remark", "label": "Remark", key: 'remark', sortable: false}},
			],
			fieldsWorkOrderExecutionNg: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"ngCategory": { "class" : "th-ng-category first-child", "label" : "Ng Category", key: 'ngCategory.name', sortable: false}}, 
				{"ngQty": { "class" : "th-ng-qty last-child", "label" : "Ng Qty", key: 'ngQty', sortable: false}}, 
			],
			workOrderExecutionNgs1 : null,
			workOrderExecutionNgs2 : null,
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelWorkOrderExecutionDetail : {},
			isShowPopupWorkOrderExecutionDetail : false,
			isShowPopupUploadWorkOrderExecutionDetail : false,
			modelWorkOrderExecutionControlTime : {},
			isShowPopupWorkOrderExecutionControlTime : false,
			isShowPopupUploadWorkOrderExecutionControlTime : false,
			filterWorkOrderExecution : null,
			currentWorkOrderExecutionPage : 1,
			workOrderExecutionPageSize: 10,
			sortByWorkOrderExecution: '',
			sortDescWorkOrderExecution: '',
			filterWorkOrderExecutionDetail : null,
			currentWorkOrderExecutionDetailPage : 1,
			workOrderExecutionDetailPageSize: 10,
			sortByWorkOrderExecutionDetail: '',
			sortDescWorkOrderExecutionDetail: '',
			sortingByWorkOrderExecutionDetail: [],
			workOrderExecutionDetails : [],
			workOrderExecutionDetailId : '',
			totalWorkOrderExecutionDetailRow : 0,
			isShowWorkOrderExecutionDetailFilter: false,
			isDownloadWorkOrderExecutionDetail: false,
			filterWorkOrderExecutionControlTime : null,
			currentWorkOrderExecutionControlTimePage : 1,
			workOrderExecutionControlTimePageSize: 10,
			sortByWorkOrderExecutionControlTime: '',
			sortDescWorkOrderExecutionControlTime: '',
			sortingByWorkOrderExecutionControlTime: [],
			workOrderExecutionControlTimes : [],
			workOrderExecutionControlTimeId : '',
			totalWorkOrderExecutionControlTimeRow : 0,
			isShowWorkOrderExecutionControlTimeFilter: false,
			isDownloadWorkOrderExecutionControlTime: false,
			workOrderProcessDetails: [],
			parts: [],
			productionControlTimeDetails: [],
			shifts: [],
			shifts: [],
			isShiftComboLoading: false,
			billOfProcessDetails: [],
			billOfProcessDetails: [],
			isBillOfProcessDetailComboLoading: false,
			machines: [],
			machines: [],
			isMachineComboLoading: false,
			userInfos: [],
			operators: [],
			isOperatorComboLoading: false,
			documentStatuss: [],
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isShiftComboLoading: false,
			isWorkOrderProcessDetailComboLoading: false,
			isBillOfProcessDetailComboLoading: false,
			isMachineComboLoading: false,
			isUserInfoComboLoading: false,
			isDocumentStatusComboLoading: false,
			isWorkOrderExecutionComboLoading: false,
			isPartComboLoading: false,
			isProductionControlTimeDetailComboLoading: false,
			sortByWorkOrderExecutionNg: '',
			sortDescWorkOrderExecutionNg: '',
			sortingByWorkOrderExecutionNg: [],
			workOrderExecutionHoldTimes: [],
			sortByWorkOrderExecutionHoldTime: '',
			sortDescWorkOrderExecutionHoldTime: '',
			sortingByWorkOrderExecutionHoldTime: [],
			isDownloadWorkOrderExecutionHoldTime: false,
		}
	},
	methods : {
		getWorkOrderExecutionHoldTimes: async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionHoldTime);
			filter.workOrderExecutionId = this.modelId;
			// if(this.sortByWorkOrderExecutionHoldTime != null) {
			// 	this.sortingByWorkorderExecutionHoldTime[this.sortByWorkOrderExecutionHoldTime] = this.sortDescWorkOrderExecutionHoldTime;
			// }
			let currentPage = (this.currentWorkOrderExecutionHoldTimePage - 1);
			if(isAddRow) {
				let totalData = this.workOrderExecutionHoldTimes + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionHoldTimes);
				currentPage = page - 1;
			}
			//disable paging start
			currentPage = null;
			this.workOrderExecutionHoldTimePageSize = 0;
			//disable paging end;
			console.log("filter woeht", filter);
			await WorkOrderExecutionHoldTime.getList(this, filter, null, currentPage, this.workOrderExecutionHoldTimePageSize).then(result => {
				this.currentWorkOrderExecutionHoldTimePage = currentPage + 1;
				this.workOrderExecutionHoldTimes = result.data
				console.log("result data", result.data);
			}).catch(error => {});
		},
		getWorkOrderExecutionNgs1 : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionNg);
			if (this.workOrderExecutionDetails[0].id == null) return;
			filter.workOrderExecutionDetailId = this.workOrderExecutionDetails[0].id;
			filter.draftMode = "1";
			if (this.sortByWorkOrderExecutionNg != null) {
				this.sortingByWorkOrderExecutionNg[this.sortByWorkOrderExecutionNg] = this.sortDescWorkOrderExecutionNg;
			}
			let currentPage = (this.currentWorkOrderExecutionNgPage1 - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderExecutionNgRow1 + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionNgPageSize1);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderExecutionNgPageSize1 = 0;
			// disable paging end
			await WorkOrderExecutionNg.getList(this, filter, this.sortingByWorkOrderExecutionNg, currentPage , this.workOrderExecutionNgPageSize1).then(result => {
				this.currentWorkOrderExecutionNgPage1 = currentPage + 1;
				this.workOrderExecutionNgs1 = result.data;
			}).catch(error => {});
		},
		getWorkOrderExecutionNgs2 : async function(isAddRow) {
			if(this.workOrderExecutionDetails[1]==null || !this.workOrderExecutionDetails[1].id) return;
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionNg);
			if (this.workOrderExecutionDetails[0].id == null) return;
			filter.workOrderExecutionDetailId = this.workOrderExecutionDetails[1].id;
			filter.draftMode = "1";
			if (this.sortByWorkOrderExecutionNg != null) {
				this.sortingByWorkOrderExecutionNg[this.sortByWorkOrderExecutionNg] = this.sortDescWorkOrderExecutionNg;
			}
			let currentPage = (this.currentWorkOrderExecutionNgPage2 - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderExecutionNgRow2 + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionNgPageSize2);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderExecutionNgPageSize2 = 0;
			// disable paging end
			await WorkOrderExecutionNg.getList(this, filter, this.sortingByWorkOrderExecutionNg, currentPage , this.workOrderExecutionNgPageSize2).then(result => {
				this.currentWorkOrderExecutionNgPage2 = currentPage + 1;
				this.workOrderExecutionNgs2 = result.data;
			}).catch(error => {});
		},
		getWorkOrderExecution : async function(id) {
			this.isBusy = true;
			WorkOrderExecution.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.workOrderProcessDetailId != null) {
					promises.push(
						this.getWorkOrderProcessDetail(this.model.workOrderProcessDetailId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				if(this.model.billOfProcessDetailId != null) {
					promises.push(
						this.getBillOfProcessDetail(this.model.billOfProcessDetailId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				if(this.model.machineId != null) {
					promises.push(
						this.getMachine(this.model.machineId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderExecution = true;
			this.filterWorkOrderExecution.id = this.modelId;
			WorkOrderExecution.downloadDataDetail(this, this.filterWorkOrderExecution).then(result => {
				this.isDownloadWorkOrderExecution = false;
			}).catch(error => { this.isDownloadWorkOrderExecution = false; })
		},
		getWorkOrderExecutionDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionDetail);
			if (this.modelId == null) return;
			filter.workOrderExecutionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByWorkOrderExecutionDetail != null) {
				this.sortingByWorkOrderExecutionDetail[this.sortByWorkOrderExecutionDetail] = this.sortDescWorkOrderExecutionDetail;
			}
			let currentPage = (this.currentWorkOrderExecutionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderExecutionDetailRow + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderExecutionDetailPageSize = 0;
			// disable paging end
			await WorkOrderExecutionDetail.getList(this, filter, this.sortingByWorkOrderExecutionDetail, currentPage , this.workOrderExecutionDetailPageSize).then(result => {
				this.currentWorkOrderExecutionDetailPage = currentPage + 1;
				this.workOrderExecutionDetails = result.data;
				this.totalWorkOrderExecutionDetailRow = result.dataCount;

				if(result.data.length > 0) {
					this.getWorkOrderExecutionNgs1();
					this.getWorkOrderExecutionNgs2();
				}

			}).catch(error => {});
		},
		getWorkOrderExecutionControlTimes : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderExecutionControlTime);
			if (this.modelId == null) return;
			filter.workOrderExecutionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByWorkOrderExecutionControlTime != null) {
				this.sortingByWorkOrderExecutionControlTime[this.sortByWorkOrderExecutionControlTime] = this.sortDescWorkOrderExecutionControlTime;
			}
			let currentPage = (this.currentWorkOrderExecutionControlTimePage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderExecutionControlTimeRow + 1;
				let page = Math.ceil(totalData/this.workOrderExecutionControlTimePageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderExecutionControlTimePageSize = 0;
			// disable paging end
			WorkOrderExecutionControlTime.getList(this, filter, this.sortingByWorkOrderExecutionControlTime, currentPage , this.workOrderExecutionControlTimePageSize).then(result => {
				this.currentWorkOrderExecutionControlTimePage = currentPage + 1;
				this.workOrderExecutionControlTimes = result.data;
				this.totalWorkOrderExecutionControlTimeRow = result.dataCount;
			}).catch(error => {});
		},
		getWorkOrderExecutions : async function(input) {
			let filter = new WorkOrderExecutionFilter();
			if (input != undefined) {
				filter.Shift = input;
			}
			this.isWorkOrderExecutionComboLoading = true;
			WorkOrderExecution.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutions = result.data
				}
				this.isWorkOrderExecutionComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderExecutions : async function(input) {
			let filter = new WorkOrderExecutionFilter();
			if (input != undefined) {
				filter.shift = input;
			}
			this.isWorkOrderExecutionComboLoading = true;
			WorkOrderExecution.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutions = result.data
				}
				this.isWorkOrderExecutionComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isWorkOrderProcessDetailComboLoading = true;
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
				this.isWorkOrderProcessDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getProductionControlTimeDetails : async function(input) {
			let filter = new ProductionControlTimeDetailFilter();
			if (input != undefined) {
				filter.standarTimeId = input;
			}
			this.isProductionControlTimeDetailComboLoading = true;
			ProductionControlTimeDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionControlTimeDetails = result.data
				}
				this.isProductionControlTimeDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getShifts : async function(input) {
			let filter = new ShiftFilter();
			if (input != undefined) {
				filter.name = input;
			}
			Shift.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.shifts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedShift(item) {
			if(item == undefined || item == null) {
				this.model.shiftId = null;
				this.model.shift = null;
			} else {
				this.model.shiftId = item.id;
				this.model.shift = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedWorkOrderProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getBillOfProcessDetails : async function(input) {
			let filter = new BillOfProcessDetailFilter();
			if (input != undefined) {
				filter.sequence = input;
			}
			BillOfProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedBillOfProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.billOfProcessDetailId = null;
				this.model.billOfProcessDetail = null;
			} else {
				this.model.billOfProcessDetailId = item.id;
				this.model.billOfProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedMachine(item) {
			if(item == undefined || item == null) {
				this.model.machineId = null;
				this.model.machine = null;
			} else {
				this.model.machineId = item.id;
				this.model.machine = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedOperator(item) {
			if(item == undefined || item == null) {
				this.model.operatorUserName = null;
				this.model.operator = null;
			} else {
				this.model.operatorUserName = item.userName;
				this.model.operator = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderProcessDetail : async function(id) {
			WorkOrderProcessDetail.getData(this, id).then(result => {
				this.model.workOrderProcessDetail = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		getBillOfProcessDetail : async function(id) {
			BillOfProcessDetail.getData(this, id).then(result => {
				this.model.billOfProcessDetail = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		getMachine : async function(id) {
			Machine.getData(this, id).then(result => {
				this.model.machine = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.workOrderExecutionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					WorkOrderExecution.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'workorderexecutionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					WorkOrderExecution.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'workorderexecutionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderExecution.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getWorkOrderExecution(id);
					});
				}
			});
		},
		onHidden() {
			this.getWorkOrderExecutions();
		},
		addRowDataWorkOrderExecutionDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.workOrderExecutionId =  this.modelId;
					WorkOrderExecutionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderExecutionDetails(true);
						this.isShowPopupWorkOrderExecutionDetail = false;
					})
				} else {
					model.workOrderExecutionId =  this.modelId;
					WorkOrderExecutionDetail.createDataDetail(this, model)
					.then(result => {
						this.getWorkOrderExecutionDetails(true);
						this.isShowPopupWorkOrderExecutionDetail = false;
					})
				}
			}
		},
		async editRowDataWorkOrderExecutionDetail(id) {
			this.workOrderExecutionDetailId = id;
			this.isShowPopupWorkOrderExecutionDetail = true; 
		},
		async deleteRowDataWorkOrderExecutionDetail(id) {
			WorkOrderExecutionDetail.deleteData(this, id).then(result => { this.getWorkOrderExecutionDetails(); });
		},
		async resetDataWorkOrderExecutionDetail() {
			this.workOrderExecutionDetailId = "";
			this.isShowPopupWorkOrderExecutionDetail = true;
		},
		async addDataWorkOrderExecutionDetail() {
			WorkOrderExecutionDetail.createData(this, { workOrderExecutionId: this.modelId })
			.then(result => {
				this.getWorkOrderExecutionDetails(true);
			})
		},
		async addFromClipboardWorkOrderExecutionDetail() {
			let workOrderProcessDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderProcessDetails.push({ workOrderProcessDetail: item, workOrderExecutionId: this.modelId });
				});
				WorkOrderExecutionDetail.addFromClipboard(this, workOrderProcessDetails).then(result => { this.getWorkOrderExecutionDetails() });
			});
		},
		async replaceFromClipboardWorkOrderExecutionDetail() {
			let workOrderProcessDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderProcessDetails.push({ workOrderProcessDetail: item, workOrderExecutionId: this.modelId });
				});
				WorkOrderExecutionDetail.replaceFromClipboard(this, workOrderProcessDetails).then(result => { this.getWorkOrderExecutionDetails() });
			});   
		},
		showPopupUploadWorkOrderExecutionDetail() {
			if(this.workOrderExecutionDetails != null && this.workOrderExecutionDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap WorkOrderExecutionDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadWorkOrderExecutionDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadWorkOrderExecutionDetail = true;
			}
		},
		uploadDataWorkOrderExecutionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderExecutionDetail = false; 
		},
		downloadWorkOrderExecutionDetail(modalEvent) {
			this.isDownloadWorkOrderExecutionDetail = true;
			this.filterWorkOrderExecutionDetail.workOrderExecutionId = this.modelId;
			WorkOrderExecutionDetail.downloadDataDetail(this, this.filterWorkOrderExecutionDetail).then(result => {
				this.isDownloadWorkOrderExecutionDetail = false;
			}).catch(error => { this.isDownloadWorkOrderExecutionDetail = false; })
		},
		saveInputWorkOrderExecutionDetail(item) {
			if (this.workOrderExecutions != null && this.workOrderExecutions != undefined  && this.workOrderExecutions.length > 0) {
				item.workOrderExecution = this.workOrderExecutions.find(q => q.id == item.workOrderExecutionId);
			}
			if (this.workOrderProcessDetails != null && this.workOrderProcessDetails != undefined  && this.workOrderProcessDetails.length > 0) {
				item.workOrderProcessDetail = this.workOrderProcessDetails.find(q => q.id == item.workOrderProcessDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderExecutionDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		addRowDataWorkOrderExecutionControlTime(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.workOrderExecutionId =  this.modelId;
					WorkOrderExecutionControlTime.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderExecutionControlTimes(true);
						this.isShowPopupWorkOrderExecutionControlTime = false;
					})
				} else {
					model.workOrderExecutionId =  this.modelId;
					WorkOrderExecutionControlTime.createDataDetail(this, model)
					.then(result => {
						this.getWorkOrderExecutionControlTimes(true);
						this.isShowPopupWorkOrderExecutionControlTime = false;
					})
				}
			}
		},
		async editRowDataWorkOrderExecutionControlTime(id) {
			this.workOrderExecutionControlTimeId = id;
			this.isShowPopupWorkOrderExecutionControlTime = true; 
		},
		async deleteRowDataWorkOrderExecutionControlTime(id) {
			WorkOrderExecutionControlTime.deleteData(this, id).then(result => { this.getWorkOrderExecutionControlTimes(); });
		},
		async resetDataWorkOrderExecutionControlTime() {
			this.workOrderExecutionControlTimeId = "";
			this.isShowPopupWorkOrderExecutionControlTime = true;
		},
		async addDataWorkOrderExecutionControlTime() {
			WorkOrderExecutionControlTime.createData(this, { workOrderExecutionId: this.modelId })
			.then(result => {
				this.getWorkOrderExecutionControlTimes(true);
			})
		},
		async addFromClipboardWorkOrderExecutionControlTime() {
			let productionControlTimes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					productionControlTimes.push({ productionControlTime: item, workOrderExecutionId: this.modelId });
				});
				WorkOrderExecutionControlTime.addFromClipboard(this, productionControlTimes).then(result => { this.getWorkOrderExecutionControlTimes() });
			});
		},
		async replaceFromClipboardWorkOrderExecutionControlTime() {
			let productionControlTimes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					productionControlTimes.push({ productionControlTime: item, workOrderExecutionId: this.modelId });
				});
				WorkOrderExecutionControlTime.replaceFromClipboard(this, productionControlTimes).then(result => { this.getWorkOrderExecutionControlTimes() });
			});   
		},
		showPopupUploadWorkOrderExecutionControlTime() {
			if(this.workOrderExecutionControlTimes != null && this.workOrderExecutionControlTimes.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap WorkOrderExecutionControlTime akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadWorkOrderExecutionControlTime = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadWorkOrderExecutionControlTime = true;
			}
		},
		uploadDataWorkOrderExecutionControlTime(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderExecutionControlTime = false; 
		},
		downloadWorkOrderExecutionControlTime(modalEvent) {
			this.isDownloadWorkOrderExecutionControlTime = true;
			this.filterWorkOrderExecutionControlTime.workOrderExecutionId = this.modelId;
			WorkOrderExecutionControlTime.downloadDataDetail(this, this.filterWorkOrderExecutionControlTime).then(result => {
				this.isDownloadWorkOrderExecutionControlTime = false;
			}).catch(error => { this.isDownloadWorkOrderExecutionControlTime = false; })
		},
		saveInputWorkOrderExecutionControlTime(item) {
			if (this.productionControlTimeDetails != null && this.productionControlTimeDetails != undefined  && this.productionControlTimeDetails.length > 0) {
				item.productionControlTime = this.productionControlTimeDetails.find(q => q.id == item.productionControlTimeId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderExecutionControlTime.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadWorkOrderExecutionDetail = false; 
			this.isShowPopupWorkOrderExecutionDetail = false; 
			if (modalType == 'WorkOrderExecutionDetail') {
				this.getWorkOrderExecutionDetails();
			}
			this.isShowPopupUploadWorkOrderExecutionControlTime = false; 
			this.isShowPopupWorkOrderExecutionControlTime = false; 
			if (modalType == 'WorkOrderExecutionControlTime') {
				this.getWorkOrderExecutionControlTimes();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowWorkOrderExecutionDetailFilter = true;
				//this.isShowWorkOrderExecutionControlTimeFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterWorkOrderExecution = new WorkOrderExecutionFilter();
		this.filterWorkOrderExecutionDetail = new WorkOrderExecutionDetailFilter();
		this.filterWorkOrderExecutionControlTime = new WorkOrderExecutionControlTimeFilter();
		//this.getWorkOrderExecutions();
		//this.getWorkOrderProcessDetails();
		//this.getParts();
		//this.getProductionControlTimeDetails();
		//this.getShifts();
		//this.getBillOfProcessDetails();
		//this.getMachines();
		//this.getUserInfos();
		//this.getDocumentStatuss();
		//this.getWorkOrderExecutionHoldTimes();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getWorkOrderExecution(id);
			} else {
				this.modelId = id;
				this.getWorkOrderExecution(id);
				this.getWorkOrderExecutionHoldTimes();
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByWorkOrderExecutionDetail : {
			handler: function() {
				this.getWorkOrderExecutionDetails();
			}
		},
		sortDescWorkOrderExecutionDetail: {
			handler: function() {
				this.getWorkOrderExecutionDetails();
			}
		},
		currentWorkOrderExecutionDetailPage: {
			handler: function() {
				this.getWorkOrderExecutionDetails();
			}
		},
		workOrderExecutionDetailPageSize : {
			handler: function() {
				this.getWorkOrderExecutionDetails();
			}
		},
		filterWorkOrderExecutionDetail: {
			handler: function() {
				this.getWorkOrderExecutionDetails();
			},
			deep: true,
		},
		sortByWorkOrderExecutionControlTime : {
			handler: function() {
				this.getWorkOrderExecutionControlTimes();
			}
		},
		sortDescWorkOrderExecutionControlTime: {
			handler: function() {
				this.getWorkOrderExecutionControlTimes();
			}
		},
		currentWorkOrderExecutionControlTimePage: {
			handler: function() {
				this.getWorkOrderExecutionControlTimes();
			}
		},
		workOrderExecutionControlTimePageSize : {
			handler: function() {
				this.getWorkOrderExecutionControlTimes();
			}
		},
		filterWorkOrderExecutionControlTime: {
			handler: function() {
				this.getWorkOrderExecutionControlTimes();
			},
			deep: true,
		},
	},
}
</script>
